import { logUsage } from 'owa-analytics';
import { tryGetGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { scrubForPii } from 'owa-config';
import React from 'react';

export interface ErrorBoundaryLoggedData {
    ActionSuccess: boolean;
    ActionFailureInfo?: React.ErrorInfo;
}

export interface ErrorBoundaryLoggedProps {
    appName?: string;
    parentName: string;
    runLogCallback: (data: ErrorBoundaryLoggedData) => void;
    resetAndThrowAfterCatch?: boolean;
    children?: React.ReactNode;
}

interface ErrorBoundaryLoggedState {
    error: Error | null;
    runLogCallback: (data: ErrorBoundaryLoggedData) => void;
}

/* eslint-disable-next-line owa-custom-rules/prefer-react-functional-components -- (https://aka.ms/OWALintWiki)
 * This react class component should be re-factored as functional component, if is not possible, write a justification.
 *	> When implementing a simple component, write it as a functional component rather than as a class component */
export class ErrorBoundaryLogged extends React.Component<ErrorBoundaryLoggedProps> {
    state: ErrorBoundaryLoggedState;
    constructor(props: ErrorBoundaryLoggedProps) {
        super(props);
        this.state = {
            error: null,
            runLogCallback: props.runLogCallback,
        };
    }

    static getDerivedStateFromError(error: Error): {
        error: Error;
    } {
        // Use to re render while the error is catched
        return { error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        const appName = this.props.appName ?? 'Places';
        // log failure

        logUsage('PlacesErrorBoundaryLogged', tryGetGlobalSettingsAccountMailboxInfo(), {
            source: this.props.parentName,
            error: scrubForPii(error.message),
            appName,
        });
        this.state.runLogCallback({ ActionSuccess: false, ActionFailureInfo: errorInfo });
        if (this.props.resetAndThrowAfterCatch) {
            this.setState({ error: null });
            throw error;
        }
    }

    componentDidMount(): void {
        // log success
        this.state.runLogCallback({ ActionSuccess: true });
    }

    render(): React.ReactNode {
        // We just render whatever we receive, and let OWA handle the exception
        return this.props.children;
    }
}
